import { render } from "./btn-home.vue?vue&type=template&id=0dc9d3a0&scoped=true"
const script = {}

import "./btn-home.vue?vue&type=style&index=0&id=0dc9d3a0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc9d3a0"]])

export default __exports__